/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
} from './EventName';

/**
 * 
 * @export
 * @interface SDKEventPersonLoggedOutV1
 */
export interface SDKEventPersonLoggedOutV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventPersonLoggedOutV1
     */
    event_name: EventName;
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventPersonLoggedOutV1
     */
    person_id: string;
}

/**
 * Check if a given object implements the SDKEventPersonLoggedOutV1 interface.
 */
export function instanceOfSDKEventPersonLoggedOutV1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;
    isInstance = isInstance && "person_id" in value;

    return isInstance;
}

export function SDKEventPersonLoggedOutV1FromJSON(json: any): SDKEventPersonLoggedOutV1 {
    return SDKEventPersonLoggedOutV1FromJSONTyped(json, false);
}

export function SDKEventPersonLoggedOutV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventPersonLoggedOutV1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
        'person_id': json['person_id'],
    };
}

export function SDKEventPersonLoggedOutV1ToJSON(value?: SDKEventPersonLoggedOutV1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_name': EventNameToJSON(value.event_name),
        'person_id': value.person_id,
    };
}

